<template lang="pug">
  Icon.icon(v-if="type === 'icon'" :name="item.type === 'task-checklist-check' ? 'notification-check' : 'notification-play'" )
  .b-task-update-notification(v-else-if="type === 'title'")
    template(v-if="item.info.type === 'description' || item.type === 'task-update-desc'")
      ._label Обновлено описание задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
    template(v-if="item.info.type === 'dates' || item.type === 'task-update-dates'")
      ._label Обновлены сроки задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        BaseProgressbar(v-bind="dateProgress")._progress
    template(v-if="item.info.type === 'description' || item.type === 'task-checklist-change'")
      ._label Обновлен чек-лист задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
    template(v-if="item.type === 'task-checklist-check'")
      ._label Отмечены пункты чек-листа задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        template(v-for="change in item.info.change")
          div(v-if="change.checked") <s>{{ cutString(change.label) }}</s>
          div(v-if="!change.checked") {{ cutString(change.label) }}
    template(v-if="item.info.type === 'status' || item.type === 'task-update-status'")
      ._label Обновлен статус задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        BaseStatus(:status="item.info.change.old")._old
        BaseStatus(:status="item.info.change.new")
    template(v-if="item.info.type === 'priority' || item.type === 'task-update-priority'")
      ._label Обновлен приоритет задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        BasePriority(:level="item.info.change.old")._old
        BasePriority(:level="item.info.change.new")
    template(v-if="item.info.type === 'manager' || item.type === 'task-update-manager'")
      ._label Обновлен ответственный в задаче
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        UserTile(:user="users.new")
    template(v-if="item.info.type === 'author' || item.type === 'task-update-author'")
      ._label Обновлен автор в задаче
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        UserTile(:user="users.new")
    template(v-if="item.info.type === 'members' || item.type === 'task-update-members'")
      ._label Обновлены участники задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
      ._info
        span._old(v-for="user in users.removed" )
          UserAvatar(:user="user" :key="user.id")
        UserAvatar(v-for="user in users.added" :user="user" :key="user.id")
    template(v-if="item.info.type === 'closure' || item.type === 'task-closure'")
      ._label Задача
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
        |  {{ item.info.change.new ? 'закрыта' : 'открыта' }}
    template(v-if="item.info.type === 'become-manager' || item.type === 'become-task-manager'")
      ._label Вы назначены ответственным по задаче
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
    template(v-if="item.type === 'become-task-author'")
      ._label Вы назначены автором задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
    template(v-if="item.info.type === 'become-member' || item.type === 'become-task-member'")
      ._label Вас добавили в список участников задачи
        Link(:to="{ name: 'task-detail', params: item.info }")  {{ item.info.taskName }}
        |  в проекте
        Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
</template>

<script>
// import convertDateToString from '@/utils/common';
import dateProgress from '@/utils/dateProgress';

import BaseProgressbar from '@/components/BaseProgressbar.vue';
import BaseStatus from '@/components/BaseStatus.vue';
import BasePriority from '@/components/BasePriority.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import UserTile from '@/components/UserTile.vue';

export default {
  name: 'NotificationTaskUpdate',
  components: {
    BaseStatus,
    BasePriority,
    UserTile,
    UserAvatar,
    BaseProgressbar,
  },
  props: {
    item: Object,
    type: String,
  },
  computed: {
    dateProgress() {
      const { info } = this.item;
      return dateProgress(info.change.new[0], info.change.new[1]);
    },
    users() {
      const { info, users, type } = this.item;
      const result = {};

      switch (info.type || type) {
        case 'manager':
        case 'task-update-manager':
        case 'task-update-author':
          result.old = users.find((u) => u.id === info.change.old);
          result.new = users.find((u) => u.id === info.change.new);
          break;
        case 'members':
        case 'task-update-members':
          result.removed = info.change.removed.map((id) => users.find((u) => u.id === id));
          result.added = info.change.added.map((id) => users.find((u) => u.id === id));
          break;
        default: break;
      }

      return result;
    },
  },
  methods: {
    cutString(string, maxLen = 30) {
      return string.length > maxLen ? `${string.slice(0, maxLen - 3).trim()}...` : string;
    },
  },
};
</script>

<style scoped lang="scss">
  .task-update-notification {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &__old {
      opacity: .5;
      position: relative;

      &:before {
        display: block;
        content: '';
        position: absolute;
        top: 50%;
        left: -5px;
        right: -5px;
        height: 1px;
        background: black;
        z-index: 1;
      }
    }

    &__info {
      display: flex;
      column-gap: 20px;
      row-gap: 10px;
      flex-wrap: wrap;

      //&--vertical {
      //  flex-direction: column;
      //  align-items: flex-start;
      //}

      &--wrap {

      }

      &--stretch {
        justify-content: stretch;
      }
    }

    &__progress {
      flex-grow: 2;
      max-width: 350px;
    }
  }
</style>
